import { StandingOfferCreate, useUserActiveOrganization } from "@/api";
import { TypographyMuted } from "@/components/typography/Muted";
import { Button } from "@/components/ui/button";
import { CopyButton } from "@/components/ui/copyButton";
import Dialog from "@/components/ui/dialog";
import { Label } from "@/components/ui/label";
import { Link } from "@tanstack/react-router";
import { generateStandingOfferURL } from "../../utils/generateStandingOfferURL";

interface Props {
  offer: StandingOfferCreate;
  onOpenChange: () => void;
}

function StandingOfferCreatedModal({ offer, onOpenChange }: Props) {
  const { activeOrganization } = useUserActiveOrganization();

  const offerURL = generateStandingOfferURL(offer.id);

  return (
    <Dialog.Root open onOpenChange={onOpenChange}>
      <Dialog.Content className="max-w-3xl w-fit">
        <Dialog.Header>
          <Dialog.Title>Offer created</Dialog.Title>
          <Dialog.Description>
            Copy and share the link below to let people subscribe to your app.
            Offers can be managed through the <i>Standing Offers</i> tab on the{" "}
            <i>Subscriptions</i> page.
          </Dialog.Description>
        </Dialog.Header>

        <Label className="mt-3">Offer URL</Label>
        <div className="flex items-center gap-x-3">
          <div className="h-9 w-fit px-3 py-1 shadow-sm min-w-36 flex flex-row items-center text-sm bg-brand-gray-50/60 dark:bg-brand-gray-800/60 border border-brand-gray-200 dark:border-brand-gray-700 rounded-md">
            <TypographyMuted className="truncate">
              <span className="text-brand-gray-700 dark:text-brand-gray-200">
                {offerURL}
              </span>
            </TypographyMuted>
          </div>
          <CopyButton copyText={offerURL} variant="ghost" />
        </div>

        <Dialog.Footer className="mt-8 flex items-center">
          <Link
            to="/organization/$organizationSlug/subscriptions"
            params={{ organizationSlug: activeOrganization?.slug || "" }}
            search={{ view: "standing-offers" }}
          >
            <Button>Continue</Button>
          </Link>
        </Dialog.Footer>
      </Dialog.Content>
    </Dialog.Root>
  );
}

export default StandingOfferCreatedModal;
